import React, { Component } from 'react';
import writtenNumber from 'written-number';

import { PDFViewer, Page, Text, Image, Document, View, StyleSheet, Font } from '@react-pdf/renderer';
import logo from "../../assets/img/logo_menu_black.png";
import { OPCIONES } from './Styles/StylesNotasCert';
import { CONSTANCIA } from './Styles/Styles';

let UcGral = 0;
let HorasGral = 0;
let promedioGral = 0
let aprobadosGral = 0
let reprobadosGral = 0;
const ELECTIVA = "ELECTIVA";

let aprobadosGral_2 = 0
let reprobadosGral_2 = 0;
let PromAcum = [];
let pags = 0;
class NotasCertificadas extends Component {

    componentWillMount = (props) => {
        PromAcum = [];
    }

    promedio = (subpromedio, uc) => {
        if (uc === 0) return null;
        let promedio = (subpromedio / uc).toFixed(2)
        if ((promedio % 1) === 0) return (subpromedio / uc);

        /* return (subpromedio / uc).toFixed(2) */
        return Math.round(subpromedio / uc)
    }

    componentDidMount = () => {
        UcGral = 0;
        HorasGral = 0;
        promedioGral = 0;
        aprobadosGral = 0;
        reprobadosGral = 0;

        aprobadosGral_2 = 0;
        reprobadosGral_2 = 0;
    }
    
    semestreContent = (semestre) => {
        const styles = StyleSheet.create(OPCIONES[0]);
        const stylesC = StyleSheet.create(CONSTANCIA[0]);
        let { historico, materias } = this.props;
        
        let matContent = 0;
        let matSemestre = materias.filter(sem => sem.semestre_num === semestre);
        matSemestre.forEach(option => {
            let histB = historico.find(resut => resut.id === option.id)
            if (histB !== undefined) matContent++;
        })
        
        let matariasContent = () => {
            let materiasSem = [];
            let numMat = 0;

            let funcionStyle = (text) => {
                const styles = StyleSheet.create(OPCIONES[0]);
                if (text.length > 39) return styles.text8_2;
                return styles.text8_1;
            }

            let llenaMateriaSem = (corte1, corte2, corte3, codigo, nombre, prelacion1, prelacion2, horas, uc, tiposa, nota, nLetras, modalidad) => {
                numMat++;

                let notaCuad = (mod) => {
                    let notaC = "APROBADO";
                    if (nota === "02") notaC = "REPROBADO";

                    if (mod === 0) return (
                        <Text style={[styles.col16_4, styles.text4_2, {paddingTop: 3, minHeight: 15}]}>{notaC}</Text>
                    )
                        
                    return (
                        <React.Fragment>
                            <Text style={[styles.col16_3, styles.text4_2, {paddingTop: 3, minHeight: 15}]}>{nota}</Text>
                            <Text style={[styles.col16_1, styles.text4_2, {paddingTop: 3, minHeight: 15}]}>{nLetras}</Text>
                        </React.Fragment>
                    )
                }

                let periodo = () => {
                    switch(true){
                        case (corte1 !== undefined && corte1 !== ""): return corte1
                        case (corte2 !== undefined && corte2 !== ""): return corte2
                        case (corte3 !== undefined && corte3 !== ""): return corte3
                        default: return null
                    }
                }

                let num = Math.floor(Math.random()*10000000000)
                let color = "#ffffff"
                if (numMat%2 === 0) color = "#f7f7f7"

                materiasSem.push(
                    <View key = {num} style={[styles.borde5, styles.row, {backgroundColor: color}]}>
                        <Text style={[styles.col16_1, styles.text4_2, {paddingTop: 3, minHeight: 15}]}>{codigo}</Text>
                        <Text style={[styles.col16_2, styles.text4_2_l, {paddingTop: 3, minHeight: 15}]}>{nombre}</Text>
                        <Text style={[styles.col16_1, styles.text4_2, {paddingTop: 3, minHeight: 15}]}>{periodo()}</Text>
                        {notaCuad(modalidad)}
                        



                        {/* <Text style={[styles.col3_4, styles.text4_1, {paddingTop: 2}]}>{corte1}</Text>
                        <Text style={[styles.col3_4, styles.text4_1, {paddingTop: 2}]}>{corte2}</Text>
                        <Text style={[styles.col3_4, styles.text4_1, {paddingTop: 2}]}>{corte3}</Text>
                        <Text style={[styles.col3_6, styles.text8, {paddingTop: 2, textAlign: 'left'}]}>{codigo}</Text>
                        <Text style={[styles.col8, funcionStyle(nombre), {paddingTop: 2}]}>{nombre}</Text>
                        <Text style={[styles.col3_2_1, styles.text8_3, {paddingTop: 2}]}>{prelacion1}</Text>
                        <Text style={[styles.col3_2_1, styles.text8_3, {paddingTop: 2}]}>{prelacion2}</Text>
                        <Text style={[styles.col3_1, styles.text4, {paddingTop: 2}]}>{horas}</Text>
                        <Text style={[styles.col3_8, styles.text4, {paddingTop: 2}]}>{uc}</Text>
                        <Text style={[styles.col3_9, styles.text4, {paddingTop: 2}]}>{tiposa}</Text>
                        {notaCuad(modalidad)} */}
                    </View>
                )
            }

            let mTop = 0;
            let totalHoras = 0;
            let totalUc = 0;
            let matAprobadas = 0
            let matReprobadas = 0
            let subPromedio = 0

            let matAprobadas_2 = 0
            let matReprobadas_2 = 0

            let notaNum = (nota) => {
                if (nota.length === 1) return `0${nota}`
                return nota
            }

            let notaLetras = (nota) => {
                let letras =    ["UNO", "DOS", "TRES", "CUATRO", "CINCO", "SEIS", "SIETE", "OCHO", "NUEVE", "DIEZ",
                                "ONCE", "DOCE", "TRECE", "CATORCE", "QUINCE", "DIECISEIS", "DIECISIETE", "DIECIOCHO",
                                "DIECINUEVE", "VEINTE"]
                return (letras[nota - 1])
            }

            let promedio = (subpromedio, ap, rep) => {
                let cant = ap + rep;
                if (cant === 0 ) return null;
                promedioGral += (parseInt(subpromedio))
                let promedio = (subpromedio / cant).toFixed(2)
                if ((promedio % 1) === 0) return (subpromedio / cant);

                return promedio
            }

            let periodo = (num, mes, yyyy) => {
                let meses = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
                if (num === parseInt(mes)) return (`${meses[mes - 1]} ${yyyy}`)
            }

            let tipoSA = (nota, min, tipo) => {
                switch (tipo) {
                    case "PRESENCIAL":
                        if (parseInt(nota) < parseInt(min)) return "R"
                        return "A"
                    case "PRUEBA DE SUFICIENCIA":
                        if (parseInt(nota) < parseInt(min)) return "RS"
                        return "AS"
                    case "VERANO":
                        if (parseInt(nota) < parseInt(min)) return "RCV"
                        return "ACV"
                    default:
                        return "RT"
                }
            }
        
            for (let i in materias){
                let matHist = 0;
                if (materias[i].semestre_num === semestre){

                    for (let n in historico) {
                        /* if (historico[n].electiva !== null) {
                            if (parseInt(historico[n].electiva) === materias[i].id){
                                console.log(historico[n])
                                console.log(materias[i])
                            }
                        }else{

                        } */

                        if (historico[n].codigo === materias[i].codigo){
                            matHist++;

                            /* Totales del semestre */
                            mTop += 3;
                            totalHoras += parseInt(historico[n].horas);
                            totalUc += parseInt(historico[n].u_c);
                            if (historico[n].cuantitativo === 1) subPromedio += (parseInt(historico[n].nota)/*  * parseInt(historico[n].u_c) */) 

                            /* Totales Globales */
                            HorasGral += parseInt(historico[n].horas);
                            UcGral += parseInt(historico[n].u_c);

                            /* MATERIAS CUALITATIVAS */
                            if (notaNum(historico[n].nota) === "01" && historico[n].cuantitativo === 0){
                                matAprobadas++;
                                aprobadosGral++;
                            }

                            if (parseInt(historico[n].nota) >= parseInt(historico[n].nota_min)){
                                matAprobadas++;
                                aprobadosGral++;

                                matAprobadas_2++;
                                aprobadosGral_2++;
                            }

                            if (parseInt(historico[n].nota) < parseInt(historico[n].nota_min)){
                                
                                if (historico[n].cuantitativo === 1){
                                    matReprobadas++;
                                    reprobadosGral++;

                                    matReprobadas_2++;
                                    reprobadosGral_2++;
                                }else{
                                    if (historico[n].nota === "2") {
                                        matReprobadas++;
                                        reprobadosGral++;  
                                    }
                                }
                            }

                            llenaMateriaSem (
                                periodo(1, historico[n].corte_name, historico[n].corte_year),
                                periodo(6, historico[n].corte_name, historico[n].corte_year),
                                periodo(8, historico[n].corte_name, historico[n].corte_year),
                                historico[n].codigo,
                                historico[n].materia_name,
                                historico[n].prelacion_1,
                                historico[n].prelacion_2,
                                historico[n].horas,
                                historico[n].u_c,
                                tipoSA(historico[n].nota, historico[n].nota_min, historico[n].tipoev_name),
                                notaNum(historico[n].nota),
                                notaLetras(historico[n].nota),
                                historico[n].cuantitativo
                            )
                        }
                    }

                    let search = (materias[i].materia_name).indexOf(ELECTIVA);
                    if (search === 0) {

                        /* PARA LAS MATERIAS ELECTIVAS */

                        let cant = 0;
                        for (let n in historico) {
                            if (parseInt(historico[n].electiva) === materias[i].id){
                                
                                /* Totales del semestre */
                                mTop += 3;
                                totalHoras += parseInt(historico[n].horas);
                                totalUc += parseInt(historico[n].u_c);
                                if (historico[n].cuantitativo === 1) subPromedio += (parseInt(historico[n].nota)) 

                                /* Totales Globales */
                                HorasGral += parseInt(historico[n].horas);
                                UcGral += parseInt(historico[n].u_c);

                                /* Totales */
                                if (parseInt(historico[n].nota) >= parseInt(historico[n].nota_min)){
                                    matAprobadas++;
                                    aprobadosGral++;

                                    matAprobadas_2++;
                                    aprobadosGral_2++;
                                }
        
                                if (parseInt(historico[n].nota) < parseInt(historico[n].nota_min)){
                                    if (historico[n].cuantitativo === 1){
                                        matReprobadas++;
                                        reprobadosGral++;

                                        matReprobadas_2++;
                                        reprobadosGral_2++;
                                    }else{
                                        if (historico[n].nota === "2") {
                                            matReprobadas++;
                                            reprobadosGral++;  
                                        }
                                    }
                                }
                                
                                cant ++;
                                if (matHist === 0) {
                                    mTop += 3;
                                    llenaMateriaSem (
                                        periodo(1, historico[n].corte_name, historico[n].corte_year),
                                        periodo(6, historico[n].corte_name, historico[n].corte_year),
                                        periodo(8, historico[n].corte_name, historico[n].corte_year),
                                        historico[n].codigo,
                                        `${materias[i].materia_name} (${historico[n].materia_name})`,
                                        historico[n].prelacion_1,
                                        historico[n].prelacion_2,
                                        historico[n].horas,
                                        historico[n].u_c,
                                        tipoSA(historico[n].nota, historico[n].nota_min, historico[n].tipoev_name),
                                        notaNum(historico[n].nota),
                                        notaLetras(historico[n].nota),
                                        historico[n].cuantitativo
                                    )
                                }
                            }
                        }
                        /* Si no ha cursado la electiva */
                        if (cant === 0){
                            if (matHist === 0) {
                                mTop += 3;
                                llenaMateriaSem ("", "", "",
                                    materias[i].codigo,
                                    `${materias[i].materia_name} ()`,
                                    materias[i].prelacion_1,
                                    materias[i].prelacion_2,
                                    "", "", "", "", "", ""
                                )
                            }
                        }

                    /* Resto de las asignaturas */
                    }else{
                        if (matHist === 0) {
                            mTop += 3;
                            llenaMateriaSem ("", "", "",
                                materias[i].codigo,
                                materias[i].materia_name,
                                materias[i].prelacion_1,
                                materias[i].prelacion_2,
                                "", "", "", "", "", ""
                            )
                        }
                    }
                }
            }

            PromAcum.push(promedio(subPromedio, matAprobadas_2, matReprobadas_2))
            return materiasSem
        }

        let semestreL = (num) => {
            switch(num){
                case 1: return "PRIMER SEMESTRE"
                case 2: return "SEGUNDO SEMESTRE"
                case 3: return "TERCER SEMESTRE"
                case 4: return "CUARTO SEMESTRE"
                case 5: return "QUINTO SEMESTRE"
                case 6: return "SEXTO SEMESTRE"
                default: return null;
            }
        }


        let breaks = () => {
            if (semestre === 3 || semestre === 5) return (<Text break />)
        }

        if (matContent === 0) return null;

        return (
            <React.Fragment>
                {breaks()}
                <View>
                    <Text style={[stylesC.encabezado2, {fontFamily: 'Helvetica-Bold', fontSize: 14, marginTop: 10}]}>{semestreL(semestre)}</Text>
                </View>
                <View style={[styles.borde5, styles.row, styles.fondo3, {marginTop: 2,}]}>
                    <Text style={[styles.col16_1, styles.text4_2, {fontFamily: 'Helvetica-Bold',paddingTop: 6}]}>CÓDIGO</Text>
                    <Text style={[styles.col16_2, styles.text4_2, {fontFamily: 'Helvetica-Bold',paddingTop: 6}]}>ASIGNATURA</Text>
                    <Text style={[styles.col16_1, styles.text4_2, {fontFamily: 'Helvetica-Bold'}]}>PERIODO ACADÉMICO</Text>
                    <Text style={[styles.col16_3, styles.text4_2, {fontFamily: 'Helvetica-Bold',paddingTop: 6}]}>NOTA</Text>
                    <Text style={[styles.col16_1, styles.text4_2, {fontFamily: 'Helvetica-Bold',paddingTop: 6}]}>LETRAS</Text>
                </View>
                {matariasContent()}
            </React.Fragment>
        )
    }

    render() {
        
        let { tipo, autData, ctrolData, estData, uc, fecha, carrera } = this.props;
        const styles = StyleSheet.create(OPCIONES[0]);
        const stylesC = StyleSheet.create(CONSTANCIA[0]);

        let fechaD = () => {
            let diaActual = new Date(this.props.fecha);
            let day = diaActual.getDate();
            let meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre' ]
            let month = meses[diaActual.getMonth()];
            let year = diaActual.getFullYear();
        
            return `${day} días del mes de ${month} de ${year}`
        }

        let nombre = () => {
            let nombre2 = "";
            if (estData.nombre_2 !== null) nombre2 = estData.nombre_2
            return `${estData.nombre_1} ${nombre2}`
        }

        let apellido = () => {
            let ape2 = "";
            if (estData.apellido_2 !== null) ape2 = estData.apellido_2
            return `${estData.apellido_1} ${ape2}`
        }

        let EstudianteN = () => (`${nombre()} ${apellido()}`);

        let tipoFirmante = (tipo) => {
            if (tipo === 1) return "DIRECTORA"
            if (tipo === 0) return "JEFE CONTROL DE ESTUDIOS"
        }

        let nacionalidad = (tipo) => {
            if (estData.nacionalidad === tipo) return "X";
            return "*";
        }

        let tipoDocumento = (tipo) => {
            if (tipo === "C"){
                if (estData.ci !== "" && estData.ci !== null) return "X";
            }else if(tipo === "P"){
                if (estData.pasaporte !== "" && estData.pasaporte !== null) return "X";
            }
            return "*";
        }

        let tipoDocumentoC = (tipo) => {
            if (tipo === 1) return "NOTAS CERTIFICADAS";
            return "NOTAS SIMPLES";
        }

        let nombreAut = (tipo) => {
            if (tipo === 1) return `${autData.aut_name} ${autData.aut_ape}`;
            return `${ctrolData.aut_name} ${ctrolData.aut_ape}`;
        }

        let ciAut = (tipo) => {
            if (tipo === 1) return autData.cedula;
            return ctrolData.cedula; 
        }

        let diaLetras = () => {
           let fec = writtenNumber(this.props.fecha.getDate(), {lang: 'es'});
           return fec.toUpperCase()
        }
        
        let meses = () => {
            let meses = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO", "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"]
            return meses[this.props.fecha.getMonth()]
        }

        let yearLetras = () => {
            let year = this.props.fecha.getFullYear();
            let fec = writtenNumber(year, {lang: 'es'});
            return fec.toUpperCase()
        }

        let yearNum = () => {
            return this.props.fecha.getFullYear();
        }

        let proG = () => {
            let prom = 0;
            PromAcum.forEach(option => {
                prom += parseFloat(option);
            })

            return((prom / PromAcum.length).toFixed(2));
        }

        Font.registerHyphenationCallback(word => [word]);
        
        return (
            <PDFViewer style={[styles.section]}>
                <Document title={tipo}>
                    <Page size="LETTER" style={styles.body} wrap = {true}>
                        <View fixed style = {{marginBottom: 20}}>
                            <Image style={[stylesC.logo, {marginBottom: 30}]} src={logo} />
                            <Text style={[stylesC.encabezado2, {fontFamily: 'Helvetica-Bold'}]}>INSTITUTO UNIVERSITARIO DE DISEÑO LAS MERCEDES</Text>
                            <Text style={stylesC.encabezado5}>M.E. Nº 130 G.O. Nº 36.719  9 JUNIO 1.999</Text>
                        </View>
                        <Text style={[stylesC.parrafo, stylesC.lineH]} hyphenationCallback = {4}>
                            Quien suscribe, {nombreAut(tipo)}, titular de la Cédula de Identidad V-{ciAut(tipo)} {tipoFirmante(tipo)} del Instituto Universitario De Diseño Las Mercedes,   certifica que el (la) ciudadano (a):
                        </Text>

                        <Text style={[stylesC.nombre, {marginTop: 10, marginBottom: 10, fontFamily: 'Helvetica-Bold'}]}>
                            {EstudianteN()}
                        </Text>
                        <Text style={[stylesC.parrafo, stylesC.lineH, {marginTop: 10}]}>
                            Titular de la Cédula de Identidad {`${estData.nacionalidad} ${estData.ci}`}, cursó en este Instituto Universitario las asignaturas que a continuación se indican con sus respectivas calificaciones:
                        </Text>

                        <Text style={[stylesC.parrafo, stylesC.lineH, {marginTop: 10}]}>
                            Carrera: {carrera.carrera_name}
                        </Text>

                        {this.semestreContent(1)}
                        {this.semestreContent(2)}
                        {this.semestreContent(3)}
                        {this.semestreContent(4)}
                        {this.semestreContent(5)}
                        {this.semestreContent(6)}

                        <Text break />

                        <Text style={[stylesC.parrafo, stylesC.lineH, {marginTop: 40, fontFamily: 'Helvetica-Bold'}]}>
                            El índice de rendimiento académico es de {proG()} puntos.
                        </Text>
                        <Text style={[stylesC.parrafo, stylesC.lineH, {marginTop: 10}]}>
                            Se expide la presente Certificación a favor de el (la) ciudadano (a) <Text style = {{fontFamily: 'Helvetica-Bold'}}>{EstudianteN()}</Text>, titular de la Cédula de Identidad <Text style = {{fontFamily: 'Helvetica-Bold'}}>{`${estData.nacionalidad} ${estData.ci}`}</Text>, en Caracas, a los {fechaD()}.
                        </Text>

                        <Text style={[stylesC.encabezado2, {marginTop: 40, fontFamily: 'Helvetica-Bold'}]}>{nombreAut(tipo)}</Text>
                        <Text style={[stylesC.encabezado2, {fontSize: 9}]}>{tipoFirmante(tipo)}</Text>

                        <Text style={[stylesC.parrafo, stylesC.lineH, {marginTop: 10, fontFamily: 'Helvetica-Bold'}]}>OBSERVACIONES:</Text>
                        <Text style={[stylesC.parrafo, stylesC.lineH, {fontSize: 9}]} render={({ pageNumber, totalPages }) => {
                            if (pageNumber === totalPages) return `Este documento consta de ${pageNumber} páginas.`
                        }} fixed/>
                        <Text style={[stylesC.parrafo, stylesC.lineH, {fontSize: 9}]}>La escala de calificaciones es de uno (1) a veinte (20) puntos.</Text>
                        <Text style={[stylesC.parrafo, stylesC.lineH, {fontSize: 9}]}>La nota mínima aprobatoria es de diez (10) puntos.</Text>
                        
                        <View style={[stylesC.footer4]} fixed>
                            <View style={[stylesC.row]}>
                                <View style={[stylesC.col11]}>
                                <Text style={[stylesC.parrafo2, stylesC.lineH, {fontSize: 8, textAlign: 'right'}]} render={({ pageNumber, totalPages }) => (
                                    `${pageNumber} de ${totalPages}`
                                )} fixed/>
                                    <Text style={[stylesC.linea3]}></Text>
                                    <Text style={[stylesC.encabezado, {fontSize: 7}]}>
                                        Av. Río de Janeiro con Calle Roraima, quinta Los Abuelos, N° 78, Urbanización Chuao, 
                                        C.P.1061  Edo Miranda - Caracas - Venezuela
                                    </Text>
                                    <Text style={[stylesC.encabezado, {marginTop: -5, fontSize: 7}]}>
                                        Telefax: +58 212 9930983 | 9939139 | 9910710.
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        );
    }
}
 
export default NotasCertificadas;


// WEBPACK FOOTER //
// ./src/components/Reportes/NotasCertificadasNew.jsx